import script from "./bottom.vue?vue&type=script&setup=true&lang=js"
export * from "./bottom.vue?vue&type=script&setup=true&lang=js"

import "./bottom.vue?vue&type=style&index=0&id=17404b67&lang=scss&scoped=true"

import exportComponent from "D:\\工作区\\exoticplay\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17404b67"]])

export default __exports__